import { render, staticRenderFns } from "./inspectionDrawerTableExpand.vue?vue&type=template&id=b3d391fa&"
import script from "./inspectionDrawerTableExpand.vue?vue&type=script&lang=js&"
export * from "./inspectionDrawerTableExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports